import {
  AnyHash,
  FieldConfig,
  FieldDataTypes,
  Uuid,
} from '@hidat/huijs-common';
import { ZonedDateTime } from '@js-joda/core';
import * as dayjs from 'dayjs';
import { SplixerResourceInterface } from './splixer-resource.interface';
import { ResourceConfig } from '@hidat/huijs-resource';
import { HashViews } from './hash-views';
import {
  splixerFieldConfigs,
  splixerSystemFields,
} from './splixer-fields.const';
import { PlayerListenerItemInterface } from './listener-item.interface';
import { SplixerResourceTypes } from './splixer-resource-types';

export const InstanceConfig = new ResourceConfig(SplixerResourceTypes.Instance)
  .addFields(
    [
      splixerFieldConfigs.uid,
      splixerFieldConfigs.status,
      new FieldConfig('listenerId', FieldDataTypes.UID),
    ],
    true,
    HashViews.player,
  )
  .addFields([
    splixerFieldConfigs.intId,
    ...splixerSystemFields,
    new FieldConfig('sourceInfo', FieldDataTypes.HASH),
    new FieldConfig('externalId'),
    new FieldConfig('lastUsedAt', FieldDataTypes.DATETIME),
  ]);

export interface PlayerInstanceInterface extends SplixerResourceInterface<number> {
  uid: Uuid | undefined;
  listenerId: Uuid | undefined;
}

export interface InstanceInterface extends PlayerInstanceInterface {
  sourceInfo: AnyHash | undefined;
  externalId: string | undefined;
  lastUsedAt: ZonedDateTime | dayjs.Dayjs | undefined;
  tenantId: Uuid | undefined;
}

/**
 * Used to post/put between player and instance controller.
 * This covers creating/fetching instances, tags, links, and most other thing in the instance controller
 */
export interface PlayerInstanceApiPayload {
  // Required on all requests
  stationId: Uuid;
  includes: string;

  //
  instanceId?: Uuid;
  listenerId?: Uuid;
  sessionId?: Uuid;

  listenerItem?: PlayerListenerItemInterface;

  // For linking listener
  email?: string;
  linkCode?: Uuid;
}
